import { render, staticRenderFns } from "./packaging-legend.vue?vue&type=template&id=58befa53&scoped=true"
import script from "./packaging-legend.vue?vue&type=script&lang=js"
export * from "./packaging-legend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58befa53",
  null
  
)

export default component.exports